import React, { useEffect, useState } from "react";
import { useTable, useSortBy, usePagination } from "react-table";
import { PrevBtn, NextBtn, PaginationWrapper, MenuOptions, MenuItem, Btn } from "../Styles/PageStyles";
import Images from "../../Images";
import tw from "tailwind-styled-components";
import Config, { PaginationLimit } from "../../Config";
import { MdModeEditOutline } from "react-icons/md";
import { useNavigate } from "react-router-dom";
import { IoMdMore } from "react-icons/io";
import moment from "moment";
import { capitalizeFirstLetter, handleCopy, truncateText } from "../../helpers";
import { IoCopySharp } from "react-icons/io5";

const Table = ({
    apiData,
    setSelectedData,
    setIsEditPartner,
    setIsDeletePartner,
}) => {
    const [data, setData] = useState([
        {
            deviceName: "",
            extractionTime: "",
            processingTime: "",
            drops: "",
            action: "",
        },
    ]);
    const navigate = useNavigate();
    const [selectedRow, setSelectedRow] = useState(null);
    const [isMobileView, setIsMobileView] = useState(window.innerWidth < 768);
    const [previousId, setPreviousId] = useState(null);
    const [currentPage, setCurrentPage] = useState(0);
    const [openActionMenu, setOpenActionMenu] = useState(null);
    const toggleRow = (index) => {
        setSelectedRow(selectedRow === index ? null : index);
    };

    const edit = (item) => {
        setIsEditPartner(true);
        setSelectedData(item);
        setOpenActionMenu(null);
    };

    const ActionBtns = (item) => {
        const openMenu = (id) => {
            setPreviousId(openActionMenu);
            setOpenActionMenu((prevId) => {
                return prevId === id ? null : id;
            });
        };

        return (
            <ActionBtnWrapper>
                {openActionMenu === item.id && (
                    <MenuOptions id="menuOptions">
                        <MenuItem
                            title="Edit Partner"
                            onClick={() => {
                                setIsEditPartner(true);
                                setSelectedData(item);
                                setOpenActionMenu(null);
                            }}
                        >
                            <MdModeEditOutline className="text-gray-700 " /> Edit Partner
                        </MenuItem>
                        {/* <MenuItem
                            onClick={() => {
                                setIsDeletePartner(true);
                                setSelectedData(item);
                                setOpenActionMenu(null);
                            }}
                        >
                            <MdDelete className="text-gray-700 " /> Delete Partner
                        </MenuItem> */}
                        {/* <MenuItem
                            onClick={() => goToDues('Tenant Info', item)}
                        >
                            <FaUser className="text-gray-700 " /> Vendor Summary
                        </MenuItem> */}
                    </MenuOptions>
                )}
                <Btn title="Actions" type="button" onClick={() => openMenu(item.id)}>
                    <IoMdMore className="text-gray-600" size={24} />
                </Btn>
            </ActionBtnWrapper>
        );
    };

    useEffect(() => {
        if (apiData) {
            const tempData = apiData.map((item) => ({
                name: getName(item),
                ownership: item?.ownershipPercentage ? (<Amount>{item?.ownershipPercentage + '%'}</Amount>) : '-',
                action: ActionBtns(item),
                properties: item.propCount,
                createdAt: moment(item.createdAt).format("DD, MMM YY"),
            }));
            setData(tempData);
        }
    }, [apiData, openActionMenu,]);

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (
                !event.target.closest("#menuOptions") &&
                !event.target.closest(".action-btn")
            ) {
                setOpenActionMenu(null);
            }
        };

        document.addEventListener("mousedown", handleClickOutside);

        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, []);



    const getName = (item) => {
        const name = capitalizeFirstLetter(item?.name);
        return (
            <UserImageWrapper>
                <div className="flex-row flex">
                    <UserImage src={item.profilePicture ? item.profilePicture : Images.Avatar} alt={`Avatar for ${item.name}`} />
                </div>
                <div className="flex flex-col gap-1">
                    <span className="text-gray-600 text-sm font-medium">
                        {truncateText(name, 25)}{""}
                    </span>
                    <div className="flex gap-1">
                        <span className="text-gray-400 text-xs">#{item.mobile}</span>
                        <button onClick={(e) => {
                            e.stopPropagation();
                            handleCopy(item.mobile);
                        }}>
                            <IoCopySharp size={10} className="text-gray-400" />
                        </button>
                    </div>
                </div>
            </UserImageWrapper>
        );
    };

    const goToDues = (clickOn, item) => {
        navigate(`/vendors-expense/${item.id}`);
    };

    useEffect(() => {
        const handleResize = () => {
            setIsMobileView(window.innerWidth < 768);
        };

        window.addEventListener("resize", handleResize);

        return () => {
            window.removeEventListener("resize", handleResize);
        };
    }, []);

    const columns = React.useMemo(() => {
        if (isMobileView) {
            // Display only "User" column for mobile screens
            return [
                {
                    Header: "Name",
                    accessor: "name",
                },
                {
                    Header: "Ownership",
                    accessor: "ownership",
                },

            ];
        }
        return [
            {
                Header: "Name",
                accessor: "name",
            },
            {
                Header: "Ownership",
                accessor: "ownership",
            },
            {
                Header: "Properties",
                accessor: "properties",
            },
            // {
            //     Header: "Type",
            //     accessor: "type",
            // },
            {
                Header: "Created At",
                accessor: "createdAt",
            },

            {
                Header: "Action",
                accessor: "action",
            },
        ];
    }, [isMobileView]);
    const {
        getTableProps,
        getTableBodyProps,
        headerGroups,
        prepareRow,
        pageOptions,
        page,
        state: { pageIndex, pageSize },
        previousPage,
        nextPage,
        setPageSize,
        canPreviousPage,
        canNextPage,
    } = useTable(
        {
            data,
            columns,
            initialState: { pageIndex: currentPage, pageSize: PaginationLimit },
        },
        useSortBy,
        usePagination
    );

    // useEffect(() => {
    //   setPageSize(PaginationLimit);
    // }, []);
    useEffect(() => {
        setCurrentPage(pageIndex); // Update current page on state change
    }, [pageIndex]);

    return (
        <>
            <CustomTable {...getTableProps()}>
                <Thead>
                    {headerGroups.map((headerGroup) => (
                        <Tr {...headerGroup.getHeaderGroupProps()}>
                            {headerGroup.headers.map((column) => (
                                <Th {...column.getHeaderProps(column.getSortByToggleProps())}>
                                    {column.render("Header")}
                                    <span>
                                        {column.isSorted ? (
                                            <img
                                                src={Images.Arrow}
                                                alt="down arrow"
                                                className={`${column.isSortedDesc ? "-rotate-90" : "rotate-90"
                                                    } w-1.5 inline-block ml-1.5`}
                                            />
                                        ) : (
                                            ""
                                        )}
                                    </span>
                                </Th>
                            ))}
                        </Tr>
                    ))}
                </Thead>
                <Tbody {...getTableBodyProps()} hasdata={(apiData?.length > 0).toString()}>
                    {page.map((row, rowIndex) => {
                        prepareRow(row);
                        const rowData = apiData[rowIndex];
                        return (
                            <React.Fragment key={rowIndex}>
                                <Tr
                                    {...row.getRowProps({ style: { height: "80px" } })}
                                    hasdata={(apiData?.length > 0).toString()}
                                >
                                    {row.cells.map((cell, cellIndex) => {
                                        return (
                                            <Td
                                                {...cell.getCellProps()}
                                                onClick={() => {
                                                    if (
                                                        cellIndex === 0 ||
                                                        (cellIndex === 1 && window.innerWidth < 768)
                                                    ) {
                                                        toggleRow(rowIndex);
                                                    }
                                                }}
                                            >
                                                {cell.render("Cell")}
                                            </Td>
                                        );
                                    })}
                                </Tr>
                                {selectedRow === rowIndex && window.innerWidth < 768 && (
                                    <Tr>
                                        <Td colSpan={columns.length}>
                                            <ul className="flex flex-col gap-2">
                                                <li>
                                                    <strong>Type</strong>{" "}
                                                    {data[rowIndex].type}
                                                </li>
                                                <li>
                                                    <strong>Action</strong>{" "}
                                                    {data[rowIndex].action}
                                                </li>

                                            </ul>
                                        </Td>
                                    </Tr>
                                )}
                            </React.Fragment>
                        );
                    })}
                </Tbody>
            </CustomTable>
            {apiData?.length > 0 && (
                <PaginationWrapper>
                    <div className="px-2">
                        Page{" "}
                        <em>
                            {pageIndex + 1} of {pageOptions.length}
                        </em>
                    </div>

                    <div className="flex gap-1">
                        <PrevBtn onClick={() => previousPage()} disabled={!canPreviousPage}>
                            <img src={Images.Arrow} alt="arrow" className="w-2 opacity-75 " />
                        </PrevBtn>
                        <NextBtn onClick={() => nextPage()} disabled={!canNextPage}>
                            <img
                                src={Images.Arrow}
                                alt="arrow"
                                className="w-2 rotate-180 opacity-75"
                            />
                        </NextBtn>
                    </div>
                </PaginationWrapper>
            )}

        </>
    );
};


const CustomTable = tw.table` w-full text-gray-600`;
const Thead = tw.thead`border-b uppercase text-gray-600 bg-blue-50`;
const Tbody = tw.tbody`${(props) => (props.hasdata === "true" ? "border-b" : "")}`;
const Tr = tw.tr`${(props) =>
    props.hasdata === "true"
        ? "border-b"
        : ""} rounded-md overflow-hidden hover:bg-slate-50`;
const Th = tw.th`text-left text-sm md:p-3 p-0.5 font-normal text-gray-600`;
const Td = tw.td`p-3 text-sm md:p-3 text-left`;
const UserImageWrapper = tw.div` flex items-center gap-2`;
const UserImage = tw.img`w-10 h-10 rounded-full `;
const ActionBtnWrapper = tw.div`flex items-center gap-3 relative`;
const Amount = tw.p`
  text-gray-800 font-semibold
  bg-neutral-100 px-3 py-1
  rounded-full inline-flex
`;

export default Table;
